<!--
 * @description:成功案例
 * @Author: wxy
 * @Date: 2020-02-11 14:05:58
 -->
<template>
  <div>
    <block-title>成功案例</block-title>
    <div class="swiper-style">
      <swiper :options="swiperOption" ref="Swiper">
        <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" :value="index">
          <img :src="slide.url" />
          <div class="title">{{ slide.title }}</div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next">
        <img src="@/assets/img/dashboard/arrow-left.png" />
      </div>
      <div class="swiper-button-prev">
        <img src="@/assets/img/dashboard/arrow-right.png" />
      </div>
    </div>
  </div>
</template>

<script>
import blockTitle from './blockTitle'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { caseList } from '@/api/dashboard'
export default {
  name: '',
  components: { blockTitle, swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 25,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperSlides: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      caseList().then(res => {
        this.swiperSlides = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-slide {
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
  box-shadow: 0px 6px 8px 0px rgba(51, 53, 155, 0.11);

  img {
    width: 100%;
    height: auto;
  }
  .title {
    color: #333;
    font-size: 12px;
    text-align: center;
    padding: 24px 0;
  }
}
.swiper-button-prev,
.swiper-button-next {
  background: none !important;
  img {
    width: 45px;
    height: auto;
  }
}
.swiper-button-prev {
  margin-left: -90px;
}
.swiper-button-next {
  margin-right: -70px;
}
</style>
